import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAccountMetadataRequest,
  getCatalogMetadataRequest,
  addReportRequest,
  getLogEntriesRequest,
  deleteReportRequest
} from "../../api";

const initialState = {
	accountMetadata: [],
	catalogMetadata: [],
	logEntries: [],
	getAccountMetadataInProgress: false,
	getAccountMetadataError: null,
	getCatalogMetadataInProgress: false,
	getCatalogMetadataError: null,
	getLogEntriesInProgress: false,
	getLogEntriesError: null,
	addReportInProgress: false,
	addReportError: null,
	deleteReportInProgress: false,
	deleteReportError: null

};

export const getAccountMetadata = createAsyncThunk(
  "report/getAccountMetadata",
  async (_, { rejectWithValue }) => {
	try {
	  const response = await getAccountMetadataRequest(_);
	  return response.data;
	} catch (error) {
	  return rejectWithValue(error.message);
	}
  },
);

export const getCatalogMetadata = createAsyncThunk(
  "report/getCatalogMetadata",
  async (_, { rejectWithValue }) => {
	try {
	  const response = await getCatalogMetadataRequest(_);
	  return response.data;
	} catch (error) {
	  return rejectWithValue(error.message);
	}
  },
);

export const getLogEntries = createAsyncThunk(
  "report/getLogEntries",
  async (_, { rejectWithValue }) => {
	try {
	  const response = await getLogEntriesRequest();
	  return response.data;
	} catch (error) {
	  return rejectWithValue(error.message);
	}
  },
);

export const addReport = createAsyncThunk(
  "report/addReport",
  async (_, { rejectWithValue }) => {
	try {
	  const response = await addReportRequest(_);
	  return response.data;
	} catch (error) {
	  return rejectWithValue(error.message);
	}
  },
);

export const deleteReport = createAsyncThunk(
  "report/deleteReport",
  async (id, { rejectWithValue }) => {
	try {
	  const response = await deleteReportRequest(id);
	  return response.data;
	} catch (error) {
	  return rejectWithValue(error.message);
	}
  },
);


export const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
	clearData(state) {
	  state.accountMetadata = [];
	  state.catalogMetadata = [];
	  state.logEntries = [];
	},
  },
  extraReducers: (builder) => {
	builder
	  .addCase(getAccountMetadata.pending, (state) => {
		state.getAccountMetadataInProgress = true;
		state.getAccountMetadataError = null;
	  })
	  .addCase(getAccountMetadata.fulfilled, (state, action) => {
		  console.log(action.payload);
		state.accountMetadata = action.payload;
		state.getAccountMetadataInProgress = false;
		state.getAccountMetadataError = null;
	  })
	  .addCase(getAccountMetadata.rejected, (state, action) => {
		state.getAccountMetadataInProgress = false;
		state.getAccountMetadataError = action.payload;
	  })
		
		.addCase(getCatalogMetadata.pending, (state) => {
			state.getCatalogMetadataInProgress = true;
			state.getCatalogMetadataError = null;
		})
		.addCase(getCatalogMetadata.fulfilled, (state, action) => {
			console.log(action.payload);
			state.catalogMetadata = action.payload;
			state.getCatalogMetadataInProgress = false;
			state.getCatalogMetadataError = null;
		})
		.addCase(getCatalogMetadata.rejected, (state, action) => {
			state.getCatalogMetadataInProgress = false;
			state.getCatalogMetadataError = action.payload;
		})
	  
	  .addCase(addReport.pending, (state) => {
		state.addReportInProgress = true;
		state.addReportError = null;
	  })
	  .addCase(addReport.fulfilled, (state, action) => {
		state.addReportInProgress = false;
		state.addReportError = null;
	  })
	  .addCase(addReport.rejected, (state, action) => {
		state.addReportInProgress = false;
		state.addReportError = action.payload;
	  })
	  .addCase(deleteReport.pending, (state) => {
		  state.deleteReportInProgress = true;
		  state.deleteReportError = null;
		})
		.addCase(deleteReport.fulfilled, (state, action) => {
		  state.deleteReportInProgress = false;
		  state.deleteReportError = null;
		})
		.addCase(deleteReport.rejected, (state, action) => {
		  state.deleteReportInProgress = false;
		  state.deleteReportError = action.payload;
		})
	  
	  .addCase(getLogEntries.pending, (state) => {
		  state.getLogEntriesInProgress = true;
		  state.getLogEntriesError = null;
		})
		.addCase(getLogEntries.fulfilled, (state, action) => {
		state.logEntries = action.payload;
		state.getLogEntriesInProgress = false;
		state.getLogEntriesError = null;
		})
		.addCase(getLogEntries.rejected, (state, action) => {
		state.getLogEntriesInProgress = false;
		state.getLogEntriesError = action.payload;
		});
	  
  },
});

export const { clearData } = reportSlice.actions;

// this is for configureStore
export default reportSlice.reducer;
